var Request = require('./helper/request');
var queryString = require('query-string');

function Wall(app){
	var self = this;
  self.request = new Request(app);

  self.routes = {
  	index: {
  		url: '/wall',
  		method: 'GET'
  	},
  };
}

Wall.prototype.index = function(params = false){
	var self = this;
  var uri;
  if (!params) {
    uri = self.routes.index.url;
  } else {
    uri = self.routes.index.url + "?" + queryString.stringify(params, {arrayFormat: "bracket"});
  }

	return self.request.get(uri);
};

Wall.prototype.paginate = function(page){
  var self = this;
  var uri = self.routes.index.url + '?page=' + page;
  return self.request.get(uri);
};

Wall.prototype.categoryIndex = function(categoryId){
  var self = this;
  var uri = self.routes.index.url + "?category_id="+categoryId;
  return self.request.get();
};

Wall.prototype.categoryPaginate = function(categoryId, page){
  var self = this;
  var uri = self.routes.index.url + '?category_id=' + categoryId + '&page=' + page;
  return self.request.get(uri);
};

Wall.prototype.tagIndex = function(tagId){
  var self = this;
  var uri = self.routes.index.url + "?tag_id=" + tagId;
  return self.request.get(uri);
}  

Wall.prototype.tagPaginate = function(tagId, page){
  var self = this;
  var uri = self.routes.index.url + "?tag_id=" + tagId + "&page=" + page;
  return self.request.get(uri);
}

module.exports = Wall;